import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { style: {"padding":"0.7rem"} }
const _hoisted_2 = { class: "white-radius" }
const _hoisted_3 = { style: {"font-size":"0.9rem"} }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { style: {"color":"#868686"} }, "服务名称 ", -1)
const _hoisted_5 = { style: {"color":"#333"} }
const _hoisted_6 = { style: {"font-size":"0.9rem"} }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { style: {"color":"#868686"} }, "服务内容 ", -1)
const _hoisted_8 = { style: {"color":"#AAA"} }
const _hoisted_9 = { style: {"font-size":"0.9rem"} }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { style: {"color":"#868686"} }, "使用说明 ", -1)
const _hoisted_11 = { style: {"color":"#AAA"} }
const _hoisted_12 = { style: {"font-size":"0.9rem"} }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { style: {"color":"#868686"} }, "服务价值 ", -1)
const _hoisted_14 = { style: {"color":"#AAA"} }
const _hoisted_15 = { style: {"font-size":"0.9rem"} }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { style: {"color":"#868686"} }, "包含次数 ", -1)
const _hoisted_17 = { style: {"color":"#AAA"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.serveArr, (item) => {
      return (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("span", _hoisted_5, _toDisplayString(item.serveName), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("span", _hoisted_8, _toDisplayString(item.serveContent), 1)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("span", _hoisted_11, _toDisplayString(item.useExplain), 1)
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("span", _hoisted_14, _toDisplayString(item.servePrice), 1)
        ]),
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _createElementVNode("span", _hoisted_17, _toDisplayString(item.serveNum), 1)
        ])
      ]))
    }), 256))
  ]))
}